module.exports = __webpack_public_path__ + "static/media/bell.6f90cd67.svg";